import { cn as a } from "../../../lib/utils.es.js";
import { jsx as t, jsxs as o } from "react/jsx-runtime";
import { CheckIcon as b, ChevronDownIcon as n, ChevronUpIcon as c } from "lucide-react";
import * as l from "@radix-ui/react-select";
function g({ ...e }) {
  return /* @__PURE__ */ t(l.Root, {
    "data-slot": "select",
    ...e
  });
}
function v({ ...e }) {
  return /* @__PURE__ */ t(l.Group, {
    "data-slot": "select-group",
    ...e
  });
}
function x({ ...e }) {
  return /* @__PURE__ */ t(l.Value, {
    "data-slot": "select-value",
    ...e
  });
}
function h({ className: e, size: i = "default", children: s, ...r }) {
  return /* @__PURE__ */ o(l.Trigger, {
    className: a("lib:flex lib:w-fit lib:items-center lib:justify-between lib:gap-2 lib:whitespace-nowrap lib:border-dark-60 lib:border-b lib:bg-transparent lib:py-2 lib:text-sm lib:outline-none lib:transition-[color,box-shadow] lib:focus-visible:border-primary lib:focus-visible:ring-[3px] lib:focus-visible:ring-primary/50 lib:disabled:cursor-not-allowed lib:disabled:opacity-50 lib:aria-invalid:border-destructive lib:aria-invalid:ring-destructive/20 lib:data-[size=default]:h-9 lib:data-[size=sm]:h-8 lib:data-[placeholder]:text-dark-60 lib:*:data-[slot=select-value]:line-clamp-1 lib:*:data-[slot=select-value]:flex lib:*:data-[slot=select-value]:items-center lib:*:data-[slot=select-value]:gap-2 lib:md:data-[size=default]:h-11 lib:[&_svg:not([class*=size-])]:size-4 lib:[&_svg:not([class*=text-])]:text-dark-60 lib:[&_svg]:pointer-events-none lib:[&_svg]:shrink-0", e),
    "data-size": i,
    "data-slot": "select-trigger",
    ...r,
    children: [s, /* @__PURE__ */ t(l.Icon, {
      asChild: !0,
      children: /* @__PURE__ */ t(n, { className: "lib:size-4 lib:opacity-50" })
    })]
  });
}
function S({ className: e, children: i, position: s = "popper", ...r }) {
  return /* @__PURE__ */ t(l.Portal, { children: /* @__PURE__ */ o(l.Content, {
    className: a("lib:data-[state=closed]:fade-out-0 lib:data-[state=open]:fade-in-0 lib:data-[state=closed]:zoom-out-95 lib:data-[state=open]:zoom-in-95 lib:data-[side=bottom]:slide-in-from-top-2 lib:data-[side=left]:slide-in-from-right-2 lib:data-[side=right]:slide-in-from-left-2 lib:data-[side=top]:slide-in-from-bottom-2 lib:relative lib:z-50 lib:max-h-60 lib:min-w-[8rem] lib:origin-(--radix-select-content-transform-origin) lib:overflow-y-auto lib:overflow-x-hidden lib:bg-popover lib:text-popover-foreground lib:shadow-md lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", s === "popper" && "lib:data-[side=left]:-translate-x-1 lib:data-[side=right]:translate-x-1 lib:data-[side=bottom]:translate-y-1 lib:data-[side=top]:-translate-y-1", e),
    "data-slot": "select-content",
    position: s,
    ...r,
    children: [
      /* @__PURE__ */ t(d, {}),
      /* @__PURE__ */ t(l.Viewport, {
        className: a("lib:p-4", s === "popper" && "lib:h-[var(--radix-select-trigger-height)] lib:w-full lib:min-w-[var(--radix-select-trigger-width)] lib:scroll-my-1"),
        children: i
      }),
      /* @__PURE__ */ t(u, {})
    ]
  }) });
}
function w({ className: e, ...i }) {
  return /* @__PURE__ */ t(l.Label, {
    className: a("lib:px-2 lib:py-1.5 lib:text-muted-foreground lib:text-xs", e),
    "data-slot": "select-label",
    ...i
  });
}
function y({ className: e, children: i, ...s }) {
  return /* @__PURE__ */ o(l.Item, {
    className: a("lib:relative lib:flex lib:w-full lib:cursor-default lib:select-none lib:items-center lib:gap-2 lib:py-1.5 lib:pr-8 lib:text-sm lib:outline-hidden lib:focus:text-primary lib:data-[disabled]:pointer-events-none lib:data-[disabled]:opacity-50 lib:[&_svg:not([class*=size-])]:size-4 lib:[&_svg:not([class*=text-])]:text-muted-foreground lib:[&_svg]:pointer-events-none lib:[&_svg]:shrink-0 lib:*:[span]:last:flex lib:*:[span]:last:items-center lib:*:[span]:last:gap-2", e),
    "data-slot": "select-item",
    ...s,
    children: [/* @__PURE__ */ t("span", {
      className: "lib:absolute lib:right-2 lib:flex lib:size-3.5 lib:items-center lib:justify-center",
      children: /* @__PURE__ */ t(l.ItemIndicator, { children: /* @__PURE__ */ t(b, { className: "lib:size-4" }) })
    }), /* @__PURE__ */ t(l.ItemText, { children: i })]
  });
}
function z({ className: e, ...i }) {
  return /* @__PURE__ */ t(l.Separator, {
    className: a("lib:pointer-events-none lib:-mx-1 lib:my-1 lib:h-px lib:bg-border", e),
    "data-slot": "select-separator",
    ...i
  });
}
function d({ className: e, ...i }) {
  return /* @__PURE__ */ t(l.ScrollUpButton, {
    className: a("lib:flex lib:cursor-default lib:items-center lib:justify-center lib:py-1", e),
    "data-slot": "select-scroll-up-button",
    ...i,
    children: /* @__PURE__ */ t(c, { className: "lib:size-4" })
  });
}
function u({ className: e, ...i }) {
  return /* @__PURE__ */ t(l.ScrollDownButton, {
    className: a("lib:flex lib:cursor-default lib:items-center lib:justify-center lib:py-1", e),
    "data-slot": "select-scroll-down-button",
    ...i,
    children: /* @__PURE__ */ t(n, { className: "lib:size-4" })
  });
}
export {
  g as UiSelect,
  S as UiSelectContent,
  v as UiSelectGroup,
  y as UiSelectItem,
  w as UiSelectLabel,
  u as UiSelectScrollDownButton,
  d as UiSelectScrollUpButton,
  z as UiSelectSeparator,
  h as UiSelectTrigger,
  x as UiSelectValue
};
